import { ProfilePictureLight } from '@/components/profile-picture/profile-picture.light';
import { Loader } from '@nosinovacao/fe-icons';
import { Button, If, useI18n } from '@nosinovacao/nosid-mfe-common';
import { type SuccessProps } from '../../-model/props';

export function SuccessLight({
  holderName,
  holderImage,
  contact,
  isPrimary,
  serviceAccounts,
  loading,
  onDone,
}: Readonly<SuccessProps>) {
  const { t } = useI18n();
  return (
    <div className="flex size-full flex-col gap-6 overflow-y-auto max-tablet:pb-8">
      <If condition={isPrimary}>
        <div className="grid gap-2">
          <span
            className="font-light text-nos-neutral-900 font-text-p1"
            data-tid="text-account-holder"
          >
            {t('Services.AddServices.Success.AccountHolder')}
          </span>
          <div className="grid grid-cols-[auto_1fr] items-center gap-x-4 gap-y-1 rounded-lg border border-nos-neutral-200 bg-nos-neutral-0 p-4">
            <ProfilePictureLight
              name={holderName}
              size={40}
              src={holderImage}
              className="row-span-2"
            />
            <span className="font-bold text-nos-neutral-900 font-text-p2">{holderName}</span>
            <span className="text-nos-neutral-900 font-text-p2">{contact ?? '-'}</span>
          </div>
        </div>
        <div className="grid gap-2">
          <span className="font-light text-nos-neutral-900 font-text-p1" data-tid="text-services">
            {t('Services.AddServices.Success.Services')}
          </span>
          <div className="grid gap-1">
            {serviceAccounts.map((service) => (
              <div
                key={service.Id}
                className="grid gap-4 rounded-lg border border-nos-neutral-200 p-4"
              >
                <span className="font-medium text-nos-neutral-900 font-title-h4">
                  {service.Package || t('Services.MainAddress.PackageFallback')}
                </span>
                <div className="grid gap-1">
                  <span className="text-nos-neutral-500 font-text-p2">
                    {t('Services.AddServices.Success.ServiceId')}
                  </span>
                  <span className="text-nos-neutral-900 font-text-p1">{service.Id}</span>
                </div>
                <div className="grid gap-1">
                  <span className="text-nos-neutral-500 font-text-p2">
                    {t('Services.AddServices.Success.Address')}
                  </span>
                  <span className="text-nos-neutral-900 font-text-p1">
                    {service.Address || t('Services.MainAddress.AddressFallback')}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </If>
      <div className="sticky bottom-0 mt-auto bg-nos-neutral-0">
        <Button
          skin="light"
          type="button"
          onClick={onDone}
          disabled={loading}
          className="w-full tablet:w-fit"
          data-tid="button-done"
        >
          <If condition={loading} otherwise={t('Services.AddServices.Success.Button')}>
            <Loader width={24} height={24} />
          </If>
        </Button>
      </div>
    </div>
  );
}
